import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Modal from "@mui/material/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import SideBar from "../components/Sidebar";
import Navbar from "../components/Navbar";

const HomeContainer = styled.div`
     height: 100vh;
     background-color: lightgray;
`;

const CardList = styled.div`
  height: calc(100vh - 70px);
  width: calc(90%);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
`;

const ProgressBar = styled.div`
  position: absolute;
  margin-top: 50vh;
  margin-left: 50vw;
`;

const View = styled.div`
  display: flex;
  height: calc(100vh-50px);
`;

const Card = styled.div`
  background-color: white;
  padding: 5px;
  margin-top: 20px;
  max-width: 700px;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  box-shadow: 5px 5px 3px 2px gray;
`;
const Row = styled.div``;
const Col = styled.div``;
const Button = styled.button``;
const Img = styled.img`
  width: 200px;
`;


const Home = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const getImage = async () => {
    setIsModalOpen(true);

    try {
      const response = await axios.get("https://e-learning-ewv6.onrender.com/");
      setData(response.data);
      setIsModalOpen(false)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getImage();
  }, []);

  return (
    <HomeContainer>
      <Navbar />
      <Modal open={isModalOpen}>
        <ProgressBar>
          <CircularProgress style={{ color: "white" }} />
        </ProgressBar>
      </Modal>

      <View>
        <SideBar></SideBar>
        <CardList>
            {data.map((items) => {
              return (
                <Card>
                  <Col>
                    <Img
                      src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                      alt="..."
                    />
                  </Col>
                  <Col>
                    <Row>
                      <h5>{items.title}</h5>
                    </Row>
                    <Row>
                      <p>
                        We provide exicillence in undrstanding th e things, You
                        are on the temple study.
                      </p>
                    </Row>
                    <Row>
                      <Link to={`/course/${items._id}`}>
                        <Button>Start Course</Button>
                      </Link>
                    </Row>
                  </Col>
                </Card>
              );
            })}
            {data.map((items) => {
              return (
                <Card>
                  <Col>
                    <Img
                      src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8ZWR1Y2F0aW9ufGVufDB8fDB8fA%3D%3D&w=1000&q=80"
                      alt="..."
                    />
                  </Col>
                  <Col>
                    <Row>
                      <h5>{items.title}</h5>
                    </Row>
                    <Row>
                      <p>
                        We provide exicillence in undrstanding th e things, You
                        are on the temple study.
                      </p>
                    </Row>
                    <Row>
                      <Link to={`/course/${items._id}`}>
                        <Button>Start Course</Button>
                      </Link>
                    </Row>
                  </Col>
                </Card>
              );
            })}
          </CardList>
      </View>
    </HomeContainer>
  );
};

export default Home;
